import { useCallback } from "react";
import { useSelector } from "react-redux";
import {
  OnestMediumSmall,
  OnestNormalSmall,
  OnestSemiBoldSmall,
} from "../../../components/styled/TextComponents";
import {
  color_blue,
  color_blue_light,
  color_green,
  color_green_light,
  color_red_default,
  color_red_ultra_light,
  color_white,
  color_yellow,
  color_yellow_light,
} from "../../../constants/colors";
import { isLessonPast } from "../../../utilities/lessonHistoryUtils";
import { useI18n } from "../../../i18n/I18nProvider";

const getLessonColor = (paymentStatus) => {
  if (paymentStatus === "Не оплачено") return color_red_ultra_light;
  if (paymentStatus === "Последний урок") return color_yellow_light;
  if (paymentStatus === "Оплачено") return color_green_light;
  return color_blue_light;
};

const getLessonStatusColor = (paymentStatus) => {
  if (paymentStatus === "Не оплачено") return color_red_default;
  if (paymentStatus === "Последний урок") return color_yellow;
  if (paymentStatus === "Оплачено") return color_green;
  return color_blue;
};

const LessonPreview = ({
  lessonData,
  onOpenModalNote,
  onOpenModalReschedule,
  lessonsCount,
  isMenuOpen,
  onToggleMenu,
}) => {
  const { t } = useI18n();
  const user = useSelector((state) => state.user);
  const timeZone =
    user.time_zone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const lessonIsPast = isLessonPast(lessonData, timeZone);
  const lessonColor = getLessonColor(lessonData.paymentStatus);
  const lessonStatusColor = getLessonStatusColor(lessonData.paymentStatus);

  const handleEditLesson = useCallback(() => {
    onOpenModalReschedule({
      ...lessonData,
      lessonStatusColor,
      lessonColor,
    });
  }, [lessonColor, lessonData, lessonStatusColor, onOpenModalReschedule]);

  const handleOpenNote = useCallback(() => {
    onOpenModalNote({
      ...lessonData,
      lessonStatusColor,
      lessonColor,
    });
  }, [lessonColor, lessonData, lessonStatusColor, onOpenModalNote]);

  const [startTime, endTime] = lessonData.timeSlot?.split(/\s*-\s*/) || [
    "",
    "",
  ];

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: lessonColor,
        display: "flex",
        flexDirection: "column",
        borderRadius: 12,
        padding: 10,
        boxSizing: "border-box",
        gap: 5,
        cursor: "pointer",
        transition: "background-color 0.3s ease, transform 0.3s ease",
      }}
      onClick={onToggleMenu}
    >
      <OnestSemiBoldSmall>{lessonData.studentName}</OnestSemiBoldSmall>
      {(lessonsCount < 5 || isMenuOpen) &&
        lessonData.paymentStatus !== "Цена не указана" && (
          <OnestMediumSmall style={{ color: lessonStatusColor }}>
            {t(lessonData.paymentStatus)}
          </OnestMediumSmall>
        )}
      <div
        style={{
          width: "100%",
          height: "auto",
          backgroundColor: color_white,
          borderRadius: 10,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          padding: "0 6px",
          boxSizing: "border-box",
        }}
      >
        <OnestNormalSmall style={{ marginTop: 8, marginBottom: 8 }}>
          {startTime}
          {(lessonsCount < 8 || isMenuOpen) && endTime ? ` - ${endTime}` : ""}
        </OnestNormalSmall>
      </div>
      {isMenuOpen && (
        <div
          style={{
            backgroundColor: color_white,
            borderRadius: 10,
            boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
            padding: 10,
            display: "flex",
            flexDirection: "column",
            gap: 10,
            transform: "scaleY(1)",
            transformOrigin: "top",
            transition: "transform 0.3s ease",
          }}
        >
          {!lessonIsPast && (
            <div
              style={{ color: color_red_default, cursor: "pointer" }}
              onClick={() => handleEditLesson(lessonData.id)}
            >
              {t("Изменить")}
            </div>
          )}
          <div
            style={{ color: color_red_default, cursor: "pointer" }}
            onClick={handleOpenNote}
          >
            {t("Заметка")}
          </div>
        </div>
      )}
    </div>
  );
};

export default LessonPreview;
